/**
 * 10.9HA — MOCHILA MAIOR (loja de 💎). Cada compra soma `step` espaços até `max`; o preço sobe
 * `priceStep` por compra (30→100 em 7 compras). Fica aqui pra loja (VipScreen) e o Game fazerem
 * a MESMA conta.
 */
import { GameConfig } from "../config/GameConfig";

export interface BagUpgradeInfo {
  /** capacidade atual (base + comprado) */
  capacity: number;
  /** capacidade após a próxima compra (ou = capacity se no máximo) */
  next: number;
  /** preço em 💎 da próxima compra (0 se no máximo) */
  price: number;
  /** já está no teto */
  full: boolean;
  max: number;
}

export function bagUpgradeInfo(bagSlots: number, baseCost: number): BagUpgradeInfo {
  const c = GameConfig.equipment.bagUpgrade;
  const capacity = GameConfig.equipment.capacity + bagSlots;
  const full = capacity >= c.max;
  const n = Math.floor(bagSlots / c.step); // compras já feitas
  return {
    capacity,
    next: full ? capacity : Math.min(c.max, capacity + c.step),
    price: full ? 0 : baseCost + c.priceStep * n,
    full,
    max: c.max,
  };
}
